import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogProps,
} from "@mui/material";
import GenshinButton from "common/components/GenshinButton";
import GenshinDialog from "common/components/GenshinDialog";
import React from "react";

type ConfirmDialogProps = DialogProps & {
  title: string;
  description: string;
  cancelLabel?: string;
  confirmLabel?: string;
  onCancel?: () => void;
  onConfirm?: () => void;
  showCancel?: boolean;
  confirmDisabled?: boolean;
};

const ConfirmDialog = (props: ConfirmDialogProps) => {
  const {
    title,
    description,
    cancelLabel = "Annuler",
    confirmLabel = "Confirmer",
    onCancel,
    onConfirm,
    showCancel = true,
    confirmDisabled = false,
    children,
    ...dialogProps
  } = props;

  return (
    <GenshinDialog {...dialogProps}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
        {children}
      </DialogContent>
      <DialogActions>
        {showCancel && (
          <GenshinButton onClick={onCancel ?? (() => {})}>
            {cancelLabel}
          </GenshinButton>
        )}
        {onConfirm && (
          <GenshinButton onClick={onConfirm} disabled={confirmDisabled}>
            {confirmLabel}
          </GenshinButton>
        )}
      </DialogActions>
    </GenshinDialog>
  );
};

export default ConfirmDialog;
